import React from "react";
import {
  CreateUser,
  UserProfile,
  UserList,
  DeactivateList,
} from "@screens/User";
import DashboardScreen from "@screens/Dashboard/DashboardScreen";
import PeopleIcon from "@material-ui/icons/People";
import FileCopyIcon from "@material-ui/icons/FileCopy";
import EventIcon from "@material-ui/icons/Event";
import SettingsIcon from "@material-ui/icons/Settings";
import ListAltOutlinedIcon from "@material-ui/icons/ListAltOutlined";
import ListIcon from "@material-ui/icons/List";
import SchoolIcon from "@material-ui/icons/School";
import HomeIcon from "@material-ui/icons/Home";
import EventAvailableIcon from "@material-ui/icons/EventAvailable";
import PageNotFound from "@components/PageNotFound";
import AccessTimeIcon from "@material-ui/icons/AccessTime";
import AttachMoneyIcon from '@material-ui/icons/AttachMoney';
import { BankLetter, CreatePayroll, Payroll, PaySlip } from "../../Payroll";
import { AddLeaves, Leave, MonthlyQuota } from "../../Leave";
import { Time, Pay, Security } from "../../Settings";
import { Requests } from "../../Requests";
import { Suggestions } from "../../Suggestions";
import { ViewAttendance } from "../../Attendance";
import { WorkFromHome } from "../../WorkFromHome";
import { AddEvent, ViewEvent } from "../../Event";
import { AddCourses, ViewCourses } from "../../Courses";
import EmployeeOnBoarding from "@screens/User/OnBoarding/EmployeeOnBoarding";
import OnboardingCategories from "@screens/User/OnBoarding/OnboardingCategories";
import EmployeeOffBoarding from "@screens/User/OffBoarding/EmployeeOffBoarding";
import OffboardingCategories from "../../User/OffBoarding/OffBoardingCategories";
import EmployeeFund from "@screens/EmployeeFund/index";

export const dashboardRoutes = [
  { path: "/", redirect: true, exact: true, to: "/dashboard" },
  { path: "/dashboard", component: DashboardScreen },
  { path: "/404", component: PageNotFound },
  { path: "/employees/create", component: CreateUser },
  { path: "/employees/deactivate", component: DeactivateList },
  { path: "/employees/offboarding", component: EmployeeOffBoarding },
  { path: "/employees/:id", component: UserProfile },
  { path: "/employees", component: UserList },
  { path: "/payroll/payslip", component: PaySlip },
  { path: "/payroll/bank-letter", component: BankLetter },
  { path: "/payroll/create", component: CreatePayroll },
  { path: "/payroll", component: Payroll },
  { path: "/leave", component: Leave },
  { path: "/leavequota", component: MonthlyQuota },
  { path: "/leave-create", component: AddLeaves },
  { path: "/setting", component: Time, exact: true },
  { path: "/setting/request", component: Requests, exact: true },
  { path: "/setting/suggestion", component: Suggestions, exact: true },
  { path: "/setting/security", component: Security, exact: true },
  { path: "/setting/pay", component: Pay },
  { path: "/attendance/view", exact: true, component: ViewAttendance },
  { path: "/wfh", exact: true, component: WorkFromHome },
  { path: "/event/view", exact: true, component: ViewEvent },
  { path: "/event-create", exact: true, component: AddEvent },
  { path: "/course/view", exact: true, component: ViewCourses },
  { path: "/course-create", exact: true, component: AddCourses },
  { path: "/onboarding", exact: true, component: EmployeeOnBoarding },
  { path: "/offboarding", exact: true, component: EmployeeOffBoarding },
  { path: "/onboarding/categoriestasks", component: OnboardingCategories },
  { path: "/offboarding/categoriestasks", component: OffboardingCategories },
  { path: "/employee-fund", component: EmployeeFund },

  { path: "", to: "/404", exact: true, redirect: true },
];

export const navigatorLinks = [
  {
    label: "Manage",
    children: [
      { path: "/dashboard", label: "Dashboard", icon: <HomeIcon /> },
      { path: "/employees", label: "Employees", icon: <PeopleIcon /> },
      { path: "/payroll", label: "Payroll", icon: <FileCopyIcon /> },
      { path: "/leave", label: "Leaves", icon: <EventIcon /> },
      { path: "/wfh", label: "Work from home", icon: <span style={{ fontSize: 20 }}>🏠</span> },
      { path: "/setting", label: "Settings", icon: <SettingsIcon /> },
      {
        path: "/attendance/view",
        label: "Attendance",
        icon: <AccessTimeIcon />,
      },
      {
        path: "/employee-fund",
        label: "Employee Fund",
        icon: <AttachMoneyIcon />,
      },
      { path: "/event/view", label: "Event", icon: <EventAvailableIcon /> },
      { path: "/course/view", label: "Courses", icon: <SchoolIcon /> },
      {
        path: "/onboarding",
        label: "OnBoarding",
        icon: <ListAltOutlinedIcon />,
      },
      {
        path: "/offboarding",
        label: "OffBoarding",
        icon: <ListIcon />,
      },
    ],
  },
];

export const headerLinks = [
  {
    group: "/dashboard",
    label: "Dashboard",
    children: [],
  },
  {
    group: "/employees",
    label: "Employees",
    children: [
      { path: "/employees", label: "Employees" },
      { path: "/employees/create", label: "Register" },
      { path: "/employees/deactivate", label: "Deactivate" },
    ],
  },
  {
    group: "/payroll",
    label: "Payroll",
    children: [
      { path: "/payroll", label: "Payroll" },
      { path: "/payroll/create", label: "Create Slips" },
      { path: "/payroll/bank-letter", label: "Bank Letter" },
      { path: "/payroll/payslip", label: "Pay Slip" },
    ],
  },
  {
    group: "/leave",
    label: "Leave",
    children: [
      { path: "/leave", label: "Leave" },
      { path: "/leavequota", label: "Leave Quota" },
      { path: "/leave-create", label: "Create Leave" },
    ],
  },
  {
    group: "/wfh",
    label: "Work from home",
    children: [{ path: "/wfh", label: "Work from home" }],
  },
  {
    group: "/setting",
    label: "Settings",
    children: [
      { path: "/setting", label: "Time" },
      { path: "/setting/request", label: "Request" },
      { path: "/setting/suggestion", label: "Suggestion" },
      { path: "/setting/pay", label: "Pay" },
      { path: "/setting/security", label: "Security" },
    ],
  },
  {
    group: "/attendance",
    label: "Attendance",
    children: [{ path: "/attendance/view", label: "View Attendance" }],
  },
  {
    group: "/employee-fund",
    label: "Employee Fund",
    children: [{ path: "/employee-fund", label: "Employee Fund" }],
  },
  {
    group: "/event",
    label: "Event",
    children: [
      { path: "/event/view", label: "View Event" },
      { path: "/event-create", label: "Create Event" },
    ],
  },
  {
    group: "/course",
    label: "Courses",
    children: [
      { path: "/course/view", label: "View Course" },
      { path: "/course-create", label: "Create Course" },
    ],
  },
  {
    group: "/onboarding",
    label: "Employee OnBoarding",
    children: [
      { path: "/onboarding", label: "Employee Onbaording" },
      {
        path: "/onboarding/categoriestasks",
        label: "Categories & Tasks",
      },
    ],
  },
  {
    group: "/offboarding",
    label: "Employee OffBoarding",
    children: [
      { path: "/offboarding", label: "Employee Offbaording" },
      {
        path: "/offboarding/categoriestasks",
        label: "Categories & Tasks",
      },
    ],
  },
];
